import { render } from "./Mission.vue?vue&type=template&id=afd3e294"
import script from "./Mission.vue?vue&type=script&lang=js"
export * from "./Mission.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__